module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0036.e7772bac.jpg";